export default "__VITE_ASSET__XRW1$VM1__"